export type TypographySize = 'large' | 'small';
export const typographySizeClassName: Record<TypographySize, string> = { small: 'small-size', large: 'large-size' };

export const generateTypographySizeClassName = (size?: TypographySize) =>
  size ? typographySizeClassName[size] : undefined;
